import esriConfig from "@arcgis/core/config";

// Previous value: ./assets
// This would resolve to /contributions/assets/
// however the assets are copied to the root, i.e. /assets
// so this path needs to be changed to reflect this.
// TODO: This path might become a problem when integrated within the HE website.
//esriConfig.assetsPath = "/assets";
esriConfig.apiKey =
  "AAPK66b83d3d289e48c399ae90b8650cba40AKbJGpMoDSnID42LxcpC-7XiebJKt6z76-_kcJsl83fvpG_x7XaevjAouO81wCtU";
export default undefined;
